/* Edition pages: the side cart moved to assets/yansh-cart.js + snippets/yansh-cart-drawer.liquid (2026-10-07), the same drawer on every page.
   This file now only keeps the order box total in step with the chosen quantity. */
(function(){
  var form=document.getElementById('buyForm');if(!form)return;
  [].forEach.call(form.querySelectorAll('input[name="qty"]'),function(i){
    i.addEventListener('change',function(){var a=document.getElementById('buyAmt');if(a)a.textContent=i.getAttribute('data-total')+' ₪'});
  });
})();
